module.exports = __webpack_public_path__ + "img/game_pc_th.a4e74e2f.png";